import React from "react";
import BarraSupDent from "../../../commons/BarraSupDent";
import Title from "../../../pages/Login/Components/title/title";
import CardSelect from "./Component/CardSelect";
import NavbarTechnician from "../../../commons/NavbarTechnician";
import "../Confirm/Confirm.css";
import firebasemanager from "../../../model/Firebase/FirebaseManager";

class Confirm extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  constructor(props) {
    super();
    this.getdentSelected = this.getdentSelected.bind(this);
    this.chargeDentSelect = this.chargeDentSelect.bind(this);
  }
  getdentSelected = () => {
    firebasemanager.dentSelected();
  };

  handleTime(e) {
    sessionStorage.setItem("timeSelect", e.target.value);
  }

  chargeDentSelect = () => {
    firebasemanager.confirmDentSelected(
      this.successCallback,
      this.failCallback
    );
  };

  successCallback = () => {
    window.location = "/homeTechnician";
  };

  failCallback(error) {
    alert(error.mesagge);
  }

  render() {
    return (
      <div className="text-center">
        <BarraSupDent />
        <Title
          text1="What time fits your schedule?"
          text2="First come first serve. This job expires in 1 hour"
        />
        <div className="pb-5">
          <CardSelect />
          <div className="mt-2">
            <div className="form-group">
              <label>Enter date and time between available time slot</label>
              <input
                name="time"
                onChange={this.handleTime}
                className="size d-block mx-auto"
                id="daysSelected"
                placeholder="Example: Monday 7th, 10AM"
              />
            </div>
          </div>
          <button
            onClick={this.chargeDentSelect}
            className="btn btn-secondary mx-auto mt-2"
          >
            CONFIRM
          </button>
        </div>
        <br />
        <br />
        <NavbarTechnician />
      </div>
    );
  }
}
export default Confirm;
